export const PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION = {
  VIEW: 'PURCHASE_REQUISITION_TYPE_OPTION_VIEW',
  ADD: 'PURCHASE_REQUISITION_TYPE_OPTION_ADD',
  EDIT: 'PURCHASE_REQUISITION_TYPE_OPTION_EDIT',
  DEL: 'PURCHASE_REQUISITION_TYPE_OPTION_DEL',
};

export const PURCHASE_REQUISITION_OPTION_GROUPS = {
  PURCHASE_CATEGORY: {
    optionGroup: 'PURCHASE_CATEGORY',
    title: 'Nhóm nghiệp vụ mua',
    listPath: '/purchase-category-option',
    fieldLabel: 'nhóm nghiệp vụ mua',
    codePlaceholder: 'Ví dụ: NEW_PURCHASE',
    namePlaceholder: 'Ví dụ: Mua hàng mới',
  },
  PRODUCT_CONDITION_TYPE: {
    optionGroup: 'PRODUCT_CONDITION_TYPE',
    title: 'Điều kiện hàng áp dụng',
    listPath: '/product-condition-type-option',
    fieldLabel: 'điều kiện hàng áp dụng',
    codePlaceholder: 'Ví dụ: USED_ONLY',
    namePlaceholder: 'Ví dụ: Hàng cũ / máy cũ',
  },
  DEFAULT_PRIORITY: {
    optionGroup: 'DEFAULT_PRIORITY',
    title: 'Mức ưu tiên mặc định',
    listPath: '/purchase-priority-option',
    fieldLabel: 'mức ưu tiên',
    codePlaceholder: 'Ví dụ: NORMAL',
    namePlaceholder: 'Ví dụ: Bình thường',
  },
};
